// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  //apiUrl: 'http://localhost:8081/api/',
  apiUrl: 'https://api-web.emurojaah.id/api/',
  // apiUrl: 'https://api-webdev.emurojaah.id/api/',
  ConfigFirebase: {
    apiKey: "AIzaSyC3_j2wkAxTVa_iF8z-x95wG8ya-y1hY3o",
    authDomain: "emurojah-firebase.firebaseapp.com",
    databaseURL: "https://emurojah-firebase.firebaseio.com",
    projectId: "emurojah-firebase",
    storageBucket: "emurojah-firebase.appspot.com",
    messagingSenderId: "405061489354",
    appId: "1:405061489354:web:9949811e94b9a893"
  }
};


/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
